/**
 * 应用启动流程模块
 */

export async function loadAllDataForApp(context = {}) {
  const {
    state,
    getAllBooks,
    getAllThoughts,
    getAllHighlights,
    getAllEssays,
    getAllBookmarks,
    loadCategories,
    loadCollections,
    loadGlobalShelfOrder,
    loadBooklists,
    getAllMusic,
    getAllPodcasts
  } = context;

  state.books = await getAllBooks();
  state.thoughts = await getAllThoughts();
  state.highlights = await getAllHighlights();
  state.essays = await getAllEssays();
  state.bookmarks = await getAllBookmarks();

  loadCategories();
  loadCollections();
  loadGlobalShelfOrder();
  loadBooklists();

  try {
    const tracks = await getAllMusic();
    state.music.tracks = tracks
      .map(t => ({
        ...t,
        url: t.fileData ? URL.createObjectURL(t.fileData) : t.url || null
      }))
      .filter((t) => {
        const url = typeof t?.url === 'string' ? t.url.trim() : '';
        if (!url) return false;
        // 旧版本可能残留无 fileData 的 blob URL（跨会话失效）
        if (!t?.fileData && /^blob:/i.test(url)) return false;
        return true;
      });
  } catch (e) {
  }

  try {
    state.music.podcasts = await getAllPodcasts();
  } catch (e) {
  }
}

export async function initAppLifecycle(context = {}) {
  const {
    initDB,
    loadAllData,
    ensureShelfViewModeModuleReady,
    loadShelfViewMode,
    ensureSiteThemeModuleReady,
    ensureReaderSettingsModuleReady,
    ensureReaderProgressModuleReady,
    ensureReaderStatsModuleReady,
    ensureReaderImmersiveModuleReady,
    ensureFormatPopoverModuleReady,
    ensureShelfSearchModuleReady,
    ensureShelfDashboardModuleReady,
    loadReaderSettings,
    loadReadingStats,
    setupEventListeners,
    setupFormatEvents,
    setupCategoryEvents,
    setupWindowControlsOverlay,
    renderCurrentView,
    updateWelcomeMessage,
    initPageScrollbar,
    triggerChunkLoadRecovery,
    showToast
  } = context;

  try {
    await initDB();
    await loadAllData();
    await ensureShelfViewModeModuleReady();
    loadShelfViewMode();
    await ensureSiteThemeModuleReady();
    await ensureReaderSettingsModuleReady();
    await ensureReaderProgressModuleReady();
    await ensureReaderStatsModuleReady();
    await ensureReaderImmersiveModuleReady();
    await ensureFormatPopoverModuleReady();
    await ensureShelfSearchModuleReady();
    await ensureShelfDashboardModuleReady();
    loadReaderSettings();
    loadReadingStats();
    setupEventListeners();
    setupFormatEvents();
    setupCategoryEvents();
    setupWindowControlsOverlay();
    renderCurrentView();
    updateWelcomeMessage();
    initPageScrollbar();
  } catch (error) {
    console.error('App init failed:', error);
    triggerChunkLoadRecovery(error);
    showToast('应用初始化失败，请刷新页面重试');
  }
}
